import styled from 'styled-components';

import * as MUI from '@mui/material';
import { Theme } from '../Theme';

export const Accordion = styled(MUI.Accordion)`
	display: flex;
	flex-direction: column;
	width: 95%;
	border-radius: 4px;
	background-color: ${Theme.white};
	align-self: center;
	box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1) !important;
	margin: 0.5rem;
`;

export const AccordionSummary = styled(MUI.AccordionSummary)``;

export const AccordionDetails = styled(MUI.AccordionDetails)``;
